import Loader from "../components/Loader";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import SubHeader from "../components/SubHeader";
import GuidedTour from "../components/GuidedTour";
import { AddStaffSchema } from "../auth/Schema";
import { Formik } from "formik";
import {
  addStaffDetails,
  fetchRoleCategories,
} from "../redux/actions/staffActions";
import { pageRoutes } from "../routes/PageRoutes";
import ErrorMessage from "../components/ErrorMessage";
import Eye from "../components/Eye";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import Select from "react-select";
import "react-phone-number-input/style.css";
import { setTourStep } from "../redux/reducers/tourReducer";

const AddTechnician = () => {
  const [runTour, setRunTour] = useState(false);
  const tooltipSeen = useSelector((state) => state?.authReducer?.tooltipSeen);
  const { active: isTourActive, step: tourStep } = useSelector(
    (state) => state?.tourReducer,
  );
  const steps = React.useMemo(
    () => [
      {
        target: ".add_technician_final_btn",
        spotlightTarget: ".add_technician_block",
        scrollTarget: ".add_technician_block",
        title: "Enter technician details",
        content:
          "Provide the technician’s information to assign tasks and manage services.",
        placement: "bottom",
        nextLabel: "Next",
        skipLabel: "Skip",
        showSkipButton: true,
      },
    ],
    [],
  );

  useEffect(() => {
    if (tooltipSeen === true) {
      setRunTour(false);
      return undefined;
    }

    if (!isTourActive || tourStep !== 9) {
      setRunTour(false);
      return undefined;
    }

    const interval = setInterval(() => {
      const el = document.querySelector(".add_technician_final_btn");

      if (el) {
        setRunTour(true);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [isTourActive, tooltipSeen, tourStep]);
  const { isLoading1, staff_data, roleOptions } = useSelector(
    (state) => state?.staffReducer,
  );
  const initialState = {
    name: "",
    role: [],
    email: "",
    phone_no: "",
    password: "",
    home_address: "",
    hourly_rate: "",
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isEye, setIsEye] = useState(false);
  const [isEye2, setIsEye2] = useState(false);
  const [isToggle, setIsToggle] = useState(false);

  const [staffDetails, setStaffDetails] = useState({});

  const [serviceCategoryOptions, setServiceCategoryOptions] = useState([]);

  useEffect(() => {
    dispatch(fetchRoleCategories());
  }, []);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const onHandleAddStaff = async (values, { setSubmitting }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) navigate(pageRoutes?.technicians);
    };
    const data = {
      name: values?.name?.trim(),
      role: values?.role ?? [],
      email: values?.email,
      phone_no: `${values?.phone_no}`,
      password: values?.password,
      home_address: values?.home_address?.trim(),
      hourly_rate: values?.hourly_rate,
    };
    dispatch(addStaffDetails({ payload: data, callback }));
  };

  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <GuidedTour
        steps={tooltipSeen === true ? [] : steps}
        run={runTour && tooltipSeen !== true && isTourActive && tourStep === 9}
        markSeenApi={false}
        onSkip={() => {
          setRunTour(false);
        }}
        onComplete={() => {
          setRunTour(false);
          dispatch(setTourStep(10));
          navigate(pageRoutes.dashboard);
        }}
      />
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar path="" />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div class="ct_px_23 ct_mt_30 pb-5">
            <div class="">
              <div className="ct_mb_30">
                <SubHeader />
              </div>

              <Formik
                initialValues={initialState}
                validationSchema={AddStaffSchema}
                onSubmit={(values, actions) => {
                  onHandleAddStaff(values, actions);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldError,
                  setFieldValue,
                }) => {
                  const selectedRoleOptions =
                    roleOptions?.filter((option) =>
                      (values?.role ?? []).includes(option?.value),
                    ) ?? [];

                  return (
                    <form>
                      <div className="add_technician_block">
                        <div className="ct_white_bg_1 pb-5 add_technician_submit_btn">
                          <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Name</strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <input
                                id="name"
                                placeholder="Enter name"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.name}
                                type="text"
                                className="form-control ct_input ct_transparent_input"
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="name"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Email </strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <input
                                id="email"
                                placeholder="Enter email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.email}
                                type="email"
                                className="form-control ct_input ct_transparent_input"
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="email"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Password </strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <div className="position-relative">
                                <input
                                  id="password"
                                  placeholder="Enter password"
                                  onBlur={handleBlur}
                                  onChange={handleChange}
                                  value={values?.password}
                                  type={isEye2 ? "text" : "password"}
                                  className="form-control ct_input pe-5 ct_transparent_input"
                                />
                                <Eye
                                  className="ab_pointer"
                                  isEye={isEye2}
                                  onClick={() => setIsEye2(!isEye2)}
                                />
                              </div>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="password"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Job Role</strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <Select
                                isMulti
                                inputId="role"
                                options={roleOptions || []}
                                placeholder="Select Job Role"
                                value={selectedRoleOptions}
                                onChange={(selectedOptions) =>
                                  setFieldValue(
                                    "role",
                                    selectedOptions?.map((item) => item?.value) ??
                                      [],
                                  )
                                }
                                onBlur={() => handleBlur({ target: { name: "role" } })}
                                classNamePrefix="react-select"
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="role"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Contact no. </strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <PhoneInput
                                id="phone_no"
                                className="form-control ct_input ct_transparent_input "
                                defaultCountry="AU"
                                placeholder="Enter contact number"
                                value={values?.phone_no}
                                onChange={(val) => {
                                  const safeVal = val ?? "";
                                  if (
                                    typeof safeVal === "string" &&
                                    safeVal.length > 2 &&
                                    isValidPhoneNumber(safeVal)
                                  ) {
                                    setFieldValue("phone_no", safeVal);
                                  } else if (!isValidPhoneNumber(safeVal)) {
                                    setFieldError(
                                      "phone_no",
                                      "Please enter valid phone number",
                                    );
                                    setFieldValue("phone_no", safeVal);
                                  }
                                }}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="phone_no"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Hourly Rate ($)</strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <input
                                id="hourly_rate"
                                type="number"
                                className="form-control ct_input ct_transparent_input"
                                placeholder="Enter hourly rate"
                                value={values.hourly_rate}
                                onBlur={handleBlur}
                                onChange={(e) => {
                                  const newValue = e.target.value;
                                  if (
                                    newValue === "" ||
                                    Number(newValue) >= 0
                                  ) {
                                    handleChange(e);
                                  }
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "-" || e.key === "e") {
                                    e.preventDefault();
                                  }
                                }}
                                onWheel={() => document.activeElement.blur()}
                              />
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="hourly_rate"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group mb-3">
                              <label className="mb-1">
                                <strong>Home Address </strong>{" "}
                                <span className="ct_required_star">*</span>
                              </label>
                              <textarea
                                id="home_address"
                                placeholder="Enter home address"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.home_address}
                                className="form-control ct_input ct_transparent_input"
                                rows="4"
                              ></textarea>
                              <ErrorMessage
                                errors={errors}
                                touched={touched}
                                fieldName="home_address"
                              />
                            </div>
                          </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-end gap-3 ct_mt_40">
                        {/* <button
                        type="button"
                       onClick={() => resetForm()}
                        class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                      >
                        Cancel
                      </button> */}
                        <button
                          type="button"
                          onClick={handleSubmit}
                          class="ct_border_radius_5 ct_h_40 ct_orange_btn add_technician_final_btn"
                        >
                          Submit
                        </button>
                        </div>
                      </div>
                    </form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTechnician;
